import React from 'react';
import i18next from 'i18next';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {numberWithSpaces} from '../../utils';
import Api from '../../api';
import Spinner from 'react-spinkit';
import classNames from 'classnames';
import makeCancelable from '../../api/cancelable';

export default class Refs extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            stats: {
                loaded: false,
                ref_url: '',
                referrals: 0,
                referral_bonus: 0,
                bonus: 0,
            },
            copied: false,
        };

        this.requests = [];
    }

    componentWillUnmount() {
        clearTimeout(this.timer);

        this.requests.forEach((cancel) => cancel());
    }

    componentDidMount() {
        const {promise, cancel} = makeCancelable(Api.affiliateStats());
        this.requests.push(cancel);

        promise.then((response) => {
            this.setState({
                stats: {
                    ...this.state.stats,
                    ...response.data,
                    loaded: true,
                },
            });
        });
    }

    componentDidUpdate() {
        if (this.state.copied) {
            this.timer = setTimeout(() => {
                this.setState({
                    copied: false,
                });
            }, 300);
        }
    }

    render() {
        const {loaded, ref_url, referrals, referral_bonus, bonus} =
            this.state.stats;

        const linkClasses = classNames(
            'refs__link-block',
            this.state.copied ? 'copied' : ''
        );

        return (
            <div className="refs">
                <div className="refs__content">
                    <span className="refs__title">{i18next.t('refs.title')}</span>
                    {loaded && (
                        <React.Fragment>
                            {referral_bonus > 0 && (
                                <React.Fragment>
                                    <div className="refs__count">
                                        {i18next.t('refs.count' )} <span>{referrals}</span>
                                    </div>
                                    <div className="refs__profit">
                                        <span>{numberWithSpaces(referral_bonus)} R</span>
                                        {i18next.t('refs.profit')}
                                    </div>
                                </React.Fragment>
                            )}

                            <p
                                className="refs__offer"
                                dangerouslySetInnerHTML={{
                                    __html: i18next.t('refs.offer', {bonus}),
                                }}
                            />
                        </React.Fragment>
                    )}

                    {!loaded && (
                        <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter"/>
                    )}
                </div>

                {loaded && (
                    <div className={linkClasses}>
                        <span>{i18next.t('refs.share')}</span>
                        <CopyToClipboard
                            text={ref_url}
                            className="link refs__link"
                            onCopy={() => this.setState({copied: true})}
                        >
                            <span>{ref_url}</span>
                        </CopyToClipboard>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Refs/Refs.jsx